;(function($) {
    'use strict';

    $(document).ready(function () {
        const playButton = $('.video-section .play-button');
        const videos = $('.video-section .video');

        playButton.on('click', function () {
            $(this).hide();
            const video = $(this).parent().prev()[0];

            video.play();
            video.setAttribute('controls', 'controls');
        });

        videos.on('pause', function () {
            for (const video of videos) {
                video.pause();
                video.removeAttribute('controls');
            }

            playButton.show();
        });
    });
})(jQuery, window, document);